import React, { useState } from 'react'
import { ModuleEntity, SidebarSubMenuEntity } from '../../../interface';
import { allFeaturedModules } from '../../../utils/constants';
import { checkActionAuthorization } from '../../../service/shared.service';

const ProductionMenuPage = () => {
    const productionMenu = [
        {
            image: "icon-supply",
            moduleName: allFeaturedModules.WhatToSupply,
            url: "/settings/production/what-to-supply",
        },
        {
            image: "icon-what-to-supply",
            moduleName: allFeaturedModules.WhyToSupply,
            url: "/settings/production/why-to-supply",
        },
        {
            image: "icon-action-required",
            moduleName: allFeaturedModules.ActionRequired,
            url: "/settings/production/action-required",
        },
        {
            image: "icon-department",
            moduleName: allFeaturedModules.Department,
            url: "/settings/production/department",
        },
        {
            image: "icon-master-item",
            moduleName: allFeaturedModules.MasterItem,
            url: "/settings/production/master-item",
        }
    ];

    const isEmpty = productionMenu.every((item) => (
        !checkActionAuthorization("list", (item.moduleName as ModuleEntity))
    ))
    return (
        <div className="content-wrapper">
            <div className="row settingWrapper">
                <div className="col-md-12">
                    <div className="row">
                        {
                            productionMenu.map((items: SidebarSubMenuEntity, index: number) => (
                                <React.Fragment key={index}>
                                    {
                                        checkActionAuthorization("list", (items.moduleName as ModuleEntity)) ?
                                            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6" key={index}>
                                                <a href={items.url} className="settingLink">
                                                    <i className={items.image}></i>
                                                    <div className="mt-3">
                                                        {items.moduleName}
                                                    </div>
                                                </a>
                                            </div>
                                            : null
                                    }
                                </React.Fragment>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductionMenuPage